import React from "react";

import "./voluntarios.css";

const Voluntarios = () => {
  return <div>Voluntarios work!!!</div>;
};

export default Voluntarios;
